import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects'
import Router from 'next/router'

import {
  UPLOAD_PROVISIONAL_RECEIPT,
  DOWNLOAD_PROVISIONAL_RECEIPT,
  GET_TAX_WITHHOLDINGS_TYPES,
  GET_PROVISIONAL_RECEIPTS,
  SUBMIT_RECEIPTS,
  DELETE_PROVISIONAL_RECEIPT,
  GET_PROVISIONAL_RECEIPTS_BY_FILTER,
  RESEND_PROVISIONAL_RECEIPT_EMAIL,
  EXPORT_PROVISIONAL_RECEIPTS,
  EXPORT_PROVISIONAL_RECEIPTS_SUCCESS,
  GET_PROVISIONAL_RECEIPT_BY_ID,
} from '../constants/ActionsTypes'

import {
  uploadReceipt,
  submitReceipts,
  getTaxWithholdingsTypes,
  getProvisionalReceipts,
  deleteReceipt,
  getProvisionalReceiptsByFilter,
  resendProvisionalReceiptEmailApi,
  downloadProvisionalReceiptApi,
  getProvisionalReceiptByIdApi,
} from '../api/provisionalReceipts'

import {
  uploadReceiptSuccess,
  uploadReceiptError,
  submitReceiptsSuccess,
  getTaxWithholdingsTypesSuccess,
  getProvisionalReceiptsSuccess,
  deleteReceiptSuccess,
  getProvisionalReceiptsByFilterSuccess,
  downloadProvisionalReceiptSuccess,
  downloadProvisionalReceiptError,
  getProvisionalReceiptsByFilterError,
  submitReceiptsError,
  resendProvisionalReceiptEmailSuccess,
  resendProvisionalReceiptEmailError,
  getProvisionalReceiptByIdSuccess,
  getProvisionalReceiptByIdError,
  showMessages,
} from '../actions'

function* uploadReceiptRequest({ payload }) {
  try {
    const { data } = yield call(uploadReceipt, payload)
    yield put(uploadReceiptSuccess(data))

    yield put(
      showMessages({
        summary: 'RECEIPT.UPLOAD_RECEIPT_SUCCESS',
        type: 'success',
      }),
    )

    Router.push({ pathname: '/provisionalReceipts' })
  } catch (error) {
    yield put(uploadReceiptError(error))

    if (error.response.data && error.response.data.message == 'RECEIPT_UPLOADED_WITHOUT_EMAIL') {
      Router.push({ pathname: '/provisionalReceipts' })
    }
  }
}

function* downloadProvisionalReceiptRequest({ payload }) {
  try {
    const { data } = yield call(downloadProvisionalReceiptApi, payload)
    yield put(downloadProvisionalReceiptSuccess(data))
  } catch (error) {
    yield put(downloadProvisionalReceiptError(error))
  }
}

function* submitReceiptsRequest({ payload }) {
  try {
    const { data } = yield call(submitReceipts, payload)
    yield put(submitReceiptsSuccess(data))
  } catch (error) {
    yield put(submitReceiptsError(error))
    // handled in interceptor
  }
}

function* getProvisionalReceiptsRequest() {
  try {
    const { data } = yield call(getProvisionalReceipts)
    yield put(getProvisionalReceiptsSuccess(data))
  } catch (error) {
    // handled in interceptor
  }
}

function* getTaxWithholdingsTypesRequest() {
  try {
    const { data } = yield call(getTaxWithholdingsTypes)
    yield put(getTaxWithholdingsTypesSuccess(data))
  } catch (error) {}
}

function* deleteReceiptRequest({ payload }) {
  try {
    const { data } = yield call(deleteReceipt, payload)
    yield put(deleteReceiptSuccess(data))
  } catch (error) {
    // handled in interceptor
  }
}

function* getProvisionalReceiptsByFilterRequest({ payload }) {
  try {
    const data = yield call(getProvisionalReceiptsByFilter, payload)
    yield put(getProvisionalReceiptsByFilterSuccess(data))
  } catch (error) {
    yield put(getProvisionalReceiptsByFilterError(error))
  }
}

function* exportProvisionalReceiptsRequest({ payload }) {
  try {
    yield call(getProvisionalReceiptsByFilter, { ...payload, isExport: true })
    yield put({ type: EXPORT_PROVISIONAL_RECEIPTS_SUCCESS })
  } catch (error) {
    yield put({ type: 'EXPORT_PROVISIONAL_RECEIPTS_ERROR', error })
  }
}

function* resendProvisionalReceiptEmailRequest({ payload }) {
  try {
    const { data } = yield call(resendProvisionalReceiptEmailApi, payload)
    yield put(resendProvisionalReceiptEmailSuccess(data))

    yield put(
      showMessages({
        summary: 'RECEIPT.RESEND_EMAIL_SUCCESS',
        type: 'success',
      }),
    )
  } catch (error) {
    yield put(resendProvisionalReceiptEmailError(error))
  }
}

function* getProvisionalReceiptByIdRequest({ payload }) {
  try {
    const data = yield call(getProvisionalReceiptByIdApi, payload)
    yield put(getProvisionalReceiptByIdSuccess(data))
  } catch (error) {
    yield put(getProvisionalReceiptByIdError(error))
  }
}

export function* uploadReceiptSaga() {
  yield takeLatest(UPLOAD_PROVISIONAL_RECEIPT, uploadReceiptRequest)
}

export function* submitReceiptsSaga() {
  yield takeLatest(SUBMIT_RECEIPTS, submitReceiptsRequest)
}

export function* getTaxWithholdingsTypesSaga() {
  yield takeLatest(GET_TAX_WITHHOLDINGS_TYPES, getTaxWithholdingsTypesRequest)
}

export function* getProvisionalReceiptsSaga() {
  yield takeEvery(GET_PROVISIONAL_RECEIPTS, getProvisionalReceiptsRequest)
}

export function* deleteReceiptSaga() {
  yield takeLatest(DELETE_PROVISIONAL_RECEIPT, deleteReceiptRequest)
}

export function* getProvisionalReceiptsByFilterSaga() {
  yield takeLatest(GET_PROVISIONAL_RECEIPTS_BY_FILTER, getProvisionalReceiptsByFilterRequest)
}

export function* exportProvisionalReceiptsSaga() {
  yield takeLatest(EXPORT_PROVISIONAL_RECEIPTS, exportProvisionalReceiptsRequest)
}

export function* resendProvisionalReceiptEmailSaga() {
  yield takeLatest(RESEND_PROVISIONAL_RECEIPT_EMAIL, resendProvisionalReceiptEmailRequest)
}

export function* downloadProvisionalReceiptSaga() {
  yield takeLatest(DOWNLOAD_PROVISIONAL_RECEIPT, downloadProvisionalReceiptRequest)
}

export function* getProvisionalReceiptByIdSaga() {
  yield takeLatest(GET_PROVISIONAL_RECEIPT_BY_ID, getProvisionalReceiptByIdRequest)
}

export default function* rootSaga() {
  yield all([
    fork(uploadReceiptSaga),
    fork(submitReceiptsSaga),
    fork(getTaxWithholdingsTypesSaga),
    fork(getProvisionalReceiptsSaga),
    fork(deleteReceiptSaga),
    fork(getProvisionalReceiptsByFilterSaga),
    fork(exportProvisionalReceiptsSaga),
    fork(resendProvisionalReceiptEmailSaga),
    fork(downloadProvisionalReceiptSaga),
    fork(getProvisionalReceiptByIdSaga),
  ])
}
